import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const currentUser = await this.userService.getCurrentUserAsync();    
    if (!currentUser?.IsRFCAdmin) {
      this.router.navigate(['/unauthorized']);
      return false;
    }
    return true;
  }
}